import { AfterViewChecked, AfterViewInit, Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { routerTransition } from '../router.animations';
import { UserService } from '../shared/services/user/user.service';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CustomValidators } from "../reset-password/custom-validators";
import { NgxSpinnerService } from "ngx-spinner";

declare var $: any;

@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.scss'],
    animations: [routerTransition()]
})
export class SignupComponent implements OnInit, OnDestroy {
    registerForm: FormGroup;
    captchaDetailsForm: FormGroup;
    loading = false;
    submitted = false;
    today: number = Date.now();
    data: any;
    selectedFile: File[] = [];
    filesToUpload: File[] = [];
    errorMessage: any;
    notvalidate = false;
    fileName: any;
    fileIcon: any;
    fileUploadConflict: boolean;
    under18Age: any;
    imagePath: any;
    captchaDetails: any;
    public trainerList: Array<{ trainerId: string, trainerName: string }> = [];

    constructor(
        public router: Router,
        private formBuilder: FormBuilder,
        private userService: UserService,
        private toastr: ToastrService,
        private spinner: NgxSpinnerService,
        private elementRef: ElementRef
    ) {
        this.data = JSON.parse(localStorage.getItem('registrationPersonData'));
        this.fileName = JSON.parse(localStorage.getItem('fileName'));
        if (this.fileName) {
            this.fileUploadConflict = true;
            const icon = this.fileName.split('.').pop();
            this.checkIcon(icon);
        }
        this.createForm(this.data);
        this.getRegistration();
    }

    getRegistration() {
        this.userService.getRegistrationService().subscribe((data: any) => {
            this.spinner.hide();
            if (data.status === true) {
                this.captchaDetails = data;
                this.imagePath = data.captchaEncode;
                this.captchaDetailsForm = this.formBuilder.group({
                    captchaAnswer: ['', Validators.required],
                    encryptedCaptchaAnswer: [this.captchaDetails.captcha],
                });
            }
        }, error => {
            this.spinner.hide();
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
        });
    }



    setDefaultData(defaultVal) {
        if (defaultVal === 'Apprentice') {
            this.onAddValidationClick();
        } else {
            this.onRemoveValidationClick();
        }

    }

    reloadCaptcha() {
        this.getRegistration();
    }

    onAddValidationClick() {
        this.registerForm.controls['apprenticeTrainerName'].setValidators([Validators.required]);
        this.registerForm.controls['apprenticeTrainerName'].updateValueAndValidity();
    }

    onRemoveValidationClick() {
        this.registerForm.controls['apprenticeTrainerName'].clearValidators();
        this.registerForm.controls['apprenticeTrainerName'].setValue(null);
        this.registerForm.controls['apprenticeTrainerName'].updateValueAndValidity();
    }

    checkIcon(icon) {
        if (icon === 'png' || icon === 'jpeg' || icon === 'jpg' || icon === 'ico' || icon === 'gif') {
            this.fileIcon = 'file-photo';
        } else if (icon === 'doc' || icon === 'docx') {
            this.fileIcon = 'file-word';
        } else if (icon === 'xlsx' || icon === 'xlsm') {
            this.fileIcon = 'file-excel';
        } else if (icon === 'ppt' || icon === 'pptm' || icon === 'pptx') {
            this.fileIcon = 'file-powerpoint';
        } else if (icon === 'pdf') {
            this.fileIcon = 'file-pdf';
        } else if (icon !== 'png' || icon !== 'jpeg' || icon !== 'jpg' || icon !== 'ico' || icon !== 'gif' || icon !== 'doc' ||
            icon !== 'docx' || icon !== 'xlsx' || icon !== 'xlsm' || icon !== 'ppt' || icon !== 'pptm' || icon !== 'pptx' ||
            icon !== 'pdf') {
            this.fileIcon = 'file';
        }
    }

    createForm(data) {
        if (data === undefined || data === null) {
            this.registerForm = this.formBuilder.group({
                title: ['Title'],
                firstName: ['', [Validators.required, Validators.pattern('^[a-zA-Z\\d]+(([\\\'\\- ][a-zA-Z\\d ])?[a-zA-Z\\d]*[\\.]*)*$'), Validators.minLength(2)]],
                middleName: ['', [Validators.pattern('^[a-zA-Z\\d]+(([\\\'\\- ][a-zA-Z\\d ])?[a-zA-Z\\d]*[\\.]*)*$'), Validators.minLength(2)]],
                surname: ['', [Validators.required, Validators.pattern('^[a-zA-Z\\d]+(([\\\'\\- ][a-zA-Z\\d ])?[a-zA-Z\\d]*[\\.]*)*$'), Validators.minLength(2)]],
                dateOfBirth: ['', Validators.required],
                gender: ['', Validators.required],
                email: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9][a-zA-Z0-9-_\\.]+@([a-zA-Z]|[a-zA-Z0-9]?[a-z0-9-]+[a-zA-Z0-9])\\.[a-zA-Z0-9]{2,10}(?:\\.[a-zA-Z]{2,10})?$')]],
                addressLine1: ['', [Validators.required, Validators.pattern('^[a-zA-Z\\d]+(([\\\'\\,\\.\\- #][a-zA-Z\\d ])?[a-zA-Z\\d]*[\\.\\,\\(\\)\\[\\]\\{\\}]*)*$')]],
                addressLine2: ['', [Validators.required, Validators.pattern('^[a-zA-Z\\d]+(([\\\'\\,\\.\\- #][a-zA-Z\\d ])?[a-zA-Z\\d]*[\\.\\,\\(\\)\\[\\]\\{\\}]*)*$')]],
                addressLine3: ['', Validators.pattern('^[a-zA-Z\\d]+(([\\\'\\,\\.\\- #][a-zA-Z\\d ])?[a-zA-Z\\d]*[\\.\\,\\(\\)\\[\\]\\{\\}]*)*$')],
                county: ['', Validators.required],
                country: ['', Validators.required],
                eircode: ['', [Validators.required, Validators.pattern('[A-Za-z0-9]{6,7}')]],
                phoneCountryCode: [''],
                middlePhoneNumber: ['', [Validators.pattern('^0[0-9]{2}')]],
                phoneNumber: ['', Validators.pattern('[0-9]\\d{6}')],
                mobilePhoneNumber: ['', [Validators.required, Validators.pattern('[0-9]\\d{6}')]],
                middleMobilePhoneNumber: ['', Validators.required],
                mobileCountryCode: ['', Validators.required],
                licenceType: ['', Validators.required],
                apprenticeTrainerName: [null],
                files: [null],
            }, { validator: CustomValidators.prototype.endDateCheck });
        } else {
            this.registerForm = this.formBuilder.group({
                title: [this.data.title],
                firstName: [this.data.firstName, [Validators.required, Validators.pattern('^[a-zA-Z\\d]+(([\\\'\\- ][a-zA-Z\\d ])?[a-zA-Z\\d]*[\\.]*)*$'), Validators.minLength(2)]],
                middleName: [this.data.middleName, [Validators.pattern('^[a-zA-Z\\d]+(([\\\'\\- ][a-zA-Z\\d ])?[a-zA-Z\\d]*[\\.]*)*$'), Validators.minLength(2)]],
                surname: [this.data.surname, [Validators.required, Validators.pattern('^[a-zA-Z\\d]+(([\\\'\\- ][a-zA-Z\\d ])?[a-zA-Z\\d]*[\\.]*)*$'), Validators.minLength(2)]],
                dateOfBirth: [this.data.dateOfBirth, Validators.required],
                gender: [this.data.gender, Validators.required],
                email: [this.data.email, [Validators.required, Validators.pattern('^[a-zA-Z0-9][a-zA-Z0-9-_\\.]+@([a-zA-Z]|[a-zA-Z0-9]?[a-z0-9-]+[a-zA-Z0-9])\\.[a-zA-Z0-9]{2,10}(?:\\.[a-zA-Z]{2,10})?$')]],
                addressLine1: [this.data.addressLine1, [Validators.required, Validators.pattern('^[a-zA-Z\\d]+(([\\\'\\,\\.\\- #][a-zA-Z\\d ])?[a-zA-Z\\d]*[\\.\\,\\(\\)\\[\\]\\{\\}]*)*$')]],
                addressLine2: [this.data.addressLine2, [Validators.required, Validators.pattern('^[a-zA-Z\\d]+(([\\\'\\,\\.\\- #][a-zA-Z\\d ])?[a-zA-Z\\d]*[\\.\\,\\(\\)\\[\\]\\{\\}]*)*$')]],
                addressLine3: [this.data.addressLine3, Validators.pattern('^[a-zA-Z\\d]+(([\\\'\\,\\.\\- #][a-zA-Z\\d ])?[a-zA-Z\\d]*[\\.\\,\\(\\)\\[\\]\\{\\}]*)*$')],
                county: [this.data.county, Validators.required],
                country: [this.data.country, Validators.required],
                eircode: [this.data.eircode, [Validators.required, Validators.pattern('^[A-Za-z0-9]{6,7}')]],
                phoneCountryCode: [this.data.phoneCountryCode],
                middlePhoneNumber: [this.data.middlePhoneNumber, [Validators.pattern('^0[0-9]{2}')]],
                phoneNumber: [this.data.phoneNumber, Validators.pattern('[0-9]\\d{6}')],
                mobilePhoneNumber: [this.data.mobilePhoneNumber, [Validators.required, Validators.pattern('[0-9]\\d{6}')]],
                middleMobilePhoneNumber: [this.data.middleMobilePhoneNumber, Validators.required],
                mobileCountryCode: [this.data.mobileCountryCode, Validators.required],
                licenceType: [this.data.licenceType, Validators.required],
                apprenticeTrainerName: [this.data.apprenticeTrainerName],
                files: [this.data.files],
            }, { validator: CustomValidators.prototype.endDateCheck });
        }

    }


    number_keyPress(event: any) {
        const pattern = /[0-9]/;
        const inputChar = String.fromCharCode(event.charCode);
        if (!pattern.test(inputChar)) {
            event.preventDefault();
        }
    }

    name_keyPress(event: any) {
        const pattern = /[a-z,A-Z]/;
        const inputChar = String.fromCharCode(event.charCode);
        if (!pattern.test(inputChar)) {
            event.preventDefault();
        }
    }

    eircode_keyPress(event: any) {
        const pattern = /[A-Za-z0-9]/;
        const inputChar = String.fromCharCode(event.charCode);
        if (!pattern.test(inputChar)) {
            event.preventDefault();
        }
    }

    ngOnInit() {
        this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = 'white';
    }

    getAge(date) {
        var dob = date;
        var today = new Date();
        var birthDate = new Date(dob);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        this.under18Age = age;
    }

    doConfirmation() {
        this.submitted = true;
        if (this.registerForm.invalid || this.captchaDetailsForm.invalid) {
            return;
        }
        this.loading = true;
        this.getAge(this.registerForm.value.dateOfBirth);
        if (this.under18Age < 18) {
            this.parentVerification();
        } else {
            this.doConfirmUserData();
        }
    }

    parentVerification() {
        $('#parentVerificationModal').modal('show');
    }

    downloadForm() {
        // window.open('https://ihrb-licensing-staging.s3-eu-west-1.amazonaws.com/static-pages/downloadForm/ConsentUnder18.pdf', "_blank")
        window.open('https://ihrb-static.s3.eu-west-1.amazonaws.com/ConsentUnder18.pdf', "_blank");

    }

    doConfirmUserData() {
        localStorage.setItem('registrationPersonData', JSON.stringify(this.registerForm.value));
        localStorage.setItem('captchaDetailsData', JSON.stringify(this.captchaDetailsForm.value));
        this.router.navigate(['signup/confirmation']);
    }

    onFileChange(fileInput: any) {
        if (fileInput.target.files.length > 0) {
            let fileName;
            let totalsize = 0;
            this.notvalidate = false;
            for (let i = 0; i < fileInput.target.files.length; i++) {

                fileName = fileInput.target.files[i].name;
                const fileSize = fileInput.target.files[i].size;
                if (fileName !== undefined || fileName !== '') {
                    totalsize += Number(fileSize);
                }
            }
            const maxsize = 50 * 1024 * 1024; // 50Mb
            if (totalsize > maxsize && this.notvalidate === false) {
                this.clearFileData();
                this.notvalidate = true;
                this.errorMessage = 'Upload files cannot exceed the maximum of 50MB.';
            } else {
                this.notvalidate = false;
                this.fileUploadConflict = true;
                this.filesToUpload = <Array<File>>fileInput.target.files;
                for (let i = 0; i < this.filesToUpload.length; i++) {
                    this.selectedFile.push(fileInput.target.files[i]);
                    this.fileName = fileInput.target.files[i].name;
                    let icon = fileInput.target.files[i].name.split('.').pop();
                    this.checkIcon(icon);
                }
                var reader = new FileReader();
                reader.readAsDataURL(fileInput.target.files[0]);
                reader.onload = (event) => {
                    this.registerForm.value.files = reader.result;
                    localStorage.setItem('files', JSON.stringify(this.registerForm.value.files));
                };
                localStorage.setItem('files', JSON.stringify(this.registerForm.value.files));
                localStorage.setItem('fileName', JSON.stringify(fileInput.target.files[0].name));
                this.doConfirmUserData();
            }
        }
        $('#parentVerificationModal').modal('hide');
    }

    deleteFile() {
        this.clearFileData();
        this.notvalidate = false;
        this.fileUploadConflict = false;
    }

    clearFileData() {
        localStorage.removeItem('files');
        localStorage.removeItem('fileName');
    }

    clearRegisterData() {
        localStorage.removeItem('registrationPersonData');
        this.clearFileData();
    }

    ngOnDestroy() {
        $('#parentVerificationModal').modal('hide');
    }


}
